import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { updateMlpsPagination, getMlps, printMlpList } from '../../store/actions/mlp/mlp_action';
import { Container, Grid, Divider, Collapse } from '@material-ui/core';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import { API_ROUTES } from '../../constants/api_routes';
import MlpsTable from './mlp_table';
import useStyles from '../../classes/classes';
import { DefaultButton, BackButton, ShowFiltersButton, PrintButton, PreviewButton } from '../ui_components/common_buttons';
import AutoComplete from '../ui_components/autocomplete';
import DatePicker from '../ui_components/date_picker';
import moment from 'moment';

const MlpList = ({ mlps }) => {
    const dispatch = useDispatch();
    const classes = useStyles();

    const { page, rowsPerPage, filters } = mlps;

    useEffect(() => {
        getMlps({ page, rowsPerPage, filters });
    }, [page, rowsPerPage]);

    const handleAddMlpClick = () => {
        history.push(REACT_ROUTES.MLP);
    }

    const getPrintContent = () => dispatch(printMlpList(filters));
    const getPreviewContent = () => dispatch(printMlpList(filters));

    const handleShowFilters = () => {
        dispatch(updateMlpsPagination({ ...mlps, filters: { ...filters, showFilters: !filters.showFilters }}))
    }

    const handleCustomerObject = (object) => {
        dispatch(updateMlpsPagination({ ...mlps, filters: { ...filters, customer: object }}))
    }

    const handleStartDateChange = (object) => {
        if (moment(object).isValid()) {
            dispatch(updateMlpsPagination({ ...mlps, filters: { ...filters, startDate: moment(object) }}));
        }
    }

    const handleEndDateChange = (object) => {
        if (moment(object).isValid()) {
            dispatch(updateMlpsPagination({ ...mlps, filters: { ...filters, endDate: moment(object) }}));
        }
    }

    const handleFilterButtonClick = () => {
        if(page !=0) {
            return updateMlpsPagination({ ...mlps, page: 0 });
        }
        dispatch(getMlps({ page, rowsPerPage, filters }));
    }

    const goBack = () => {
        history.goBack();
    };

    return (
        <Container className={classes.container}>
            <h2 align="center">MLP</h2>
                <Grid container className={classes.nav_container} spacing={1}>
                    <Grid item>
                        <BackButton handleClick={goBack} />
                    </Grid>
                    <Grid item>
                        <DefaultButton label={'Kreiraj MLP'} handleClick={handleAddMlpClick} />
                    </Grid>
                    <Grid item>
                        <PrintButton getPrintContent={getPrintContent} />
                    </Grid>
                    <Grid item>
                        <PreviewButton getPreviewContent={getPreviewContent} />
                    </Grid>
                    <Grid item>
                        <ShowFiltersButton shown={filters.showFilters} handleClick={handleShowFilters} />
                    </Grid>
                </Grid>
                <Divider />
                <Collapse in={filters.showFilters}>
                <Grid container justify="center" spacing={1}>
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={8} md={8}>
                            <AutoComplete
                                name="customer"
                                label="Klijent"
                                placeholder="Klijent"
                                api={API_ROUTES.CUSTOMERS}
                                handleObject={handleCustomerObject}
                                preloadValue={filters.customer}
                            />
                        </Grid>
                    </Grid>
                    <Grid container justify="center" spacing={3}>
                    <Grid item xs={8} md={4}>
                            <DatePicker
                                name="startDate"
                                label="Od"
                                placeholder="Od"
                                fullWidth
                                value={filters.startDate}
                                onChange={handleStartDateChange}
                            />
                        </Grid>
                        <Grid item xs={8} md={4}>
                            <DatePicker
                                name="endDate"
                                label="Do"
                                placeholder="Do"
                                fullWidth
                                value={filters.endDate}
                                onChange={handleEndDateChange}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item justify="center" xs={8}>
                        <DefaultButton label={'Filtriraj'} handleClick={handleFilterButtonClick} />
                    </Grid>
            </Grid>
            </Collapse>
            <MlpsTable />
        </Container>
    )
}

MlpList.propTypes = {
    mlps: PropTypes.object
}

const mapStateToProps = (state) => ({
    mlps: state.mlps
});

export default connect(mapStateToProps)(MlpList);
